import styled from 'styled-components';
import isArray from 'lodash/isArray';
import FieldRadio from 'hive-admin/src/components/FieldRadio';
import getFilterWithCol from '../../helpers/getFilterWithCol';
import { filterSortCreatedUpdatedName } from '../../components/common';

import Types from '../../modules/types';

const RadioComponent = styled(FieldRadio.config.Component)`
  display: flex;
  width: 100%;
  > .ant-radio-button-wrapper {
    flex: 1;
    flex-shrink: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: auto;
    line-height: 100%;
    display: flex;
    padding: 8px 5px;
    white-space: nowrap;
  }
`;

const getValueForFieldDefault = (value) => (
  value && value.length ? value : undefined
);

// Search Filter
export const filterSearch = ['FilterField', {
  id: 'search',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { name: { REGEX: value, OPTIONS: 'i' } },
         // eslint-disable-next-line max-len
        { 'location.city': { REGEX: value, OPTIONS: 'i' } },
      ],
    }
  ),
  getValueForField: (value) => value || '',
  getValueForQuery: (value) => {
    value = !value ? undefined : (value.target ? value.target.value : value);
    return !value || !value.length ? undefined : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search by name, address, or city',
  }],
}];

// Store Filter
export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: (props) => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Select Store',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

// Country Filter
export const filterCountry = ['FilterField', {
  id: 'country',
  label: null,
  section: 'top',
  propsFromPage: (props) => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { 'location.country': { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'countries',
    url: '/countries/list',
    placeholder: 'Select Country',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
  }],
}];

// City Filter
export const filterCity = ['FilterField', {
  id: 'city',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { 'location.city': { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: (value) => value || '',
  getValueForQuery: (value) => {
    value = !value ? undefined : (value.target ? value.target.value : value);
    return !value || !value.length ? undefined : value;
  },
  field: ['FieldText', {
    name: 'city',
    placeholder: 'Enter City',
  }],
}];

// System Country Filter
export const filterSystemCountry = ['FilterField', {
  id: 'systemCountry',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { systemCountry: { EQ: value } },
  ),
  getValueForField: (value) => value || '',
  field: ['FieldSelect', {
    name: 'systemCountry',
    placeholder: 'Select System Country',
    choices: [
      { label: 'United Arab Emirates', value: 'ae' },
      { label: 'Saudi Arabia', value: 'sa' },
      { label: 'Kuwait', value: 'kw' },
    ],
  }],
}];

// Pagination Filter
export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

// Populate Store Filter
export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  section: 'bottom',
  build: (builder) => builder.add('populate', { store: { name: true } }),
}];

export const filterScopeToSellerStore = ['FilterHidden', {
  id: 'scopeToSellerStore',
  build: builder => builder.add('custom', { scopeToSellerStore: true }),
}];

export const filterDateType = ['FilterField', {
  id: 'date',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => {
    builder.add('custom', {
      useDate: (
        value === 'completed'
          ? 'completedAt'
          : value === 'approved'
            ? 'approvedAt'
            : value === 'shipped'
              ? 'shippedAt'
              : 'createdAt'
      ),
    });
    if (value === 'delivered') {
      // builder.add('where', { status: 'DELIVERED' });
    }
  },
  getValueForField: value => (
    value && value.length
      ? value
      : 'created'
  ),
  field: ['FieldRadio', {
    name: 'date',
    label: null,
    initialValue: 'created',
    choices: [{
      label: 'First Cycle ( 6th - 20th )',
      value: 'created',
    }, {
      label: 'Second Cycle ( 21st - 5th )',
      value: 'approved',
  }],
    Component: RadioComponent,
  }],
}];

// Export All Filters
export const ADMIN = [
  ...[
    [filterDateType, 24],
  ].map((args) => getFilterWithCol(...args)),

  filterPagination,
  filterPopulateStore,
];
// Export All Filters
export const SELLER = [
  ...[
    [filterSearch, 8],
    [filterSortCreatedUpdatedName, 8],
    [filterCountry, 12],
    [filterCity, 12],
  ].map((args) => getFilterWithCol(...args)),

  filterPagination,
  filterPopulateStore,
  filterScopeToSellerStore,
];
